import { Condition } from 'core/flow/entities';
import { Offer } from './Offer';
import { TrialCreditsOffer } from './TrialCreditsOffer';
import { UpsellOffer } from './UpsellOffer';

export type OffersMap = {
  defaultOffers: Array<Offer>;
  timeUpOffers: Array<Offer>;
  discountDefaultOffers: Array<Offer>;
  numerologyAnalysisUpsell: UpsellOffer | null;
  tarotReadingUpsell: UpsellOffer | null;
  palmistryGuideUpsell: UpsellOffer | null;
  discountOffer: Offer | null;
  ultraPackUpsell: UpsellOffer | null;
  discountUltraPackUpsell: Offer | null;
  trialCreditsUpsell: TrialCreditsOffer | null;
  premiumUpsell: Offer | null;
  discountNumerologyAnalysisUpsell: Offer | null;
  discountTarotReadingUpsell: Offer | null;
  discountPalmistryUpsell: Offer | null;
  natalChartUpsell: UpsellOffer | null;
  blackMoonUpsell: Offer | null;
  consultationUpsell: Offer | null;
  discountConsultationUpsell: Offer | null;
  readingsPackUpsellOffer: Offer | null;
};

export type OffersByCategory = {
  defaultOffers: Array<string>;
  timeUpOffers: Array<string>;
  discountDefaultOffers?: Array<string>;
  discountOffer: string;
  numerologyAnalysisUpsell: string;
  tarotReadingUpsell: string;
  palmistryGuideUpsell: string;
  ultraPackUpsell: string;
  discountUltraPackUpsell: string;
  trialCreditsUpsell: string;
  premiumUpsell?: string;
  natalChartUpsell?: string;
  blackMoonUpsell?: string;
  discountNumerologyAnalysisUpsell?: string;
  discountTarotReadingUpsell?: string;
  discountPalmistryUpsell?: string;
  consultationUpsell?: string;
  discountConsultationUpsell?: string;
  readingsPackUpsellOffer?: string;
};

type OffersCondition = {
  condition: Record<string, Condition>;
};

export type OffersAttributes = OffersByCategory & Partial<OffersCondition>;

export type StrictOffersMapByCategory = {
  [K in keyof OffersMap]: Offer | Offer[] | null;
};

export const getOfferByCategory = (offers: Offer[], offerId?: string): Offer | null => {
  if (!offerId) {
    return null;
  }

  return offers.find((offer) => offer.offerId === offerId) || null;
};

export const getOffersByCategory = (offers: Offer[], offerIds?: string[]): Offer[] => {
  if (!offerIds) {
    return [];
  }

  return offers.filter((offer) => offerIds.includes(offer.offerId));
};
